export const GetSortOptionValue = (option) => {
    if (option.indexPropertyName && option.indexPropertyName.length > 0) {
        const order = option.ascending ? 'asc' : 'dsc';
        let isEnglishFirst = option.isEnglishFirst ? 'en' : '';
        const sortOptionValue = `${option.indexPropertyName}-${option.type}-${order}${isEnglishFirst === 'en' ? '-en' : ''}`;
        return sortOptionValue;
    }
    return null;
};

export const scrollToTop = () => {
    const searchContainer = document.querySelector('.search-container');
    if (searchContainer) {
        searchContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};

export const clearTag = (tag: string): string => {
    return tag.replace(/^zz|zz$/g, '');
};